module.exports = __webpack_public_path__ + "static/media/three-days-active.a360caf7.png";